// Author Liang Gang Qiang
// Date 2021-11-22 12:04:32

class MintalMesPrdPelletizingIngredientPlanItem {
constructor({
        id = null,
        ingredientPlanId = '',
        ingredientCode = '',
        inventoryId = '',
        moisture = '',
        rate = '',
        dayCost = '',
        siloId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.ingredientPlanId = ingredientPlanId;
    this.ingredientCode = ingredientCode;
    this.inventoryId = inventoryId;
    this.moisture = moisture;
    this.rate = rate;
    this.dayCost = dayCost;
    this.siloId = siloId;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdPelletizingIngredientPlanItem();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialCode',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.materialCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grade',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.grade',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'quantity',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.quantity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moisture',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.moisture',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rate',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.rate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dayCost',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.dayCost',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'siloName',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.siloName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    ingredientPlanIdFilter : '',
    ingredientCodeFilter : '',
    inventoryIdFilter : '',
    moistureFilter : '',
    rateFilter : '',
    dayCostFilter : '',
    siloIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'ingredientCodeFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.filter.ingredientCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdPelletizingIngredientPlan'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"ingredientPlanId":"id"}'
                }
        },
        {
        key: 'inventoryIdFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.filter.inventoryId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesInventoryMaterialQuantity'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'moistureFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.filter.moisture',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rateFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.filter.rate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dayCostFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.filter.dayCost',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'siloIdFilter',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.filter.siloId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'imfMstLocation'
            ,showLabelSelectOne: true
                    ,selectFilter:{machineType: '5'}
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'ingredientCode',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.ingredientCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdPelletizingIngredientPlan'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"ingredientPlanId":"id"}'
                }
        },
        {
        key: 'inventoryId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.inventoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesInventoryMaterialQuantity'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'moisture',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.moisture',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rate',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.rate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'dayCost',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.dayCost',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'siloId',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.siloId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'imfMstLocation'
            ,showLabelSelectOne: true
                    ,selectFilter:{machineType: '5'}
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdPelletizingIngredientPlanItem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdPelletizingIngredientPlanItem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
